

export const GalleryItem = ({ Title, Img }) => {
  return (
    <div className="canva-item">
        <div className="canva-item-img">
            <img src={ Img } alt={Title} />
        </div>
        <hr />
        <div className="canva-item-body">
            <h3>{ Title }</h3>
            <input type="checkbox" name="Checked" />
        </div>
    </div>
  )
}
